import React, { useState, useEffect } from 'react';
import Breadcrumbs from '@/components/breadcrumbs';
import { colors } from '@/theme';

import * as Enums from '@/utils/enums';
import StockTransactionList from '@/PageComponents/StockTransaction/StockTransactionList';
import { createFileRoute } from '@tanstack/react-router'



function StockTransactionListPage(props: any) {

    return (
        <div className="list-container">
            <div className="row">
                <div className="title">
                    <Breadcrumbs
                        crumbs={[
                            { text: 'Stock Transactions', link: '', suppressLink: true },
                            { text: 'Stock Transactions', link: '/stocktransaction/list' },
                        ]}
                    />
                </div>
            </div>
            <div>
                <StockTransactionList
                    stockTransactionType={Enums.StockTransactionType.GRV}
                />
            </div>

            <style jsx>{`
        .inverted {
          background-color: ${colors.blueDark};
        }
        .column {
          width: 100%;
        }
        .column-margin {
          margin-left: 24px;
        }
        .button-container {
          flex-shrink: 0;
          width: 10rem;
        }
        .button-container :global(.button){
          margin-top: 0.5rem;
        }
        .row {
          display: flex;
          justify-content: space-between;
        }
        .end {
          align-items: flex-end;
        }
        .padded {
          padding-bottom: 1rem;
        }
        .row.top-gap {
          margin-top: 2.5rem;
        }
        .search-container :global(.search) {
          width: 528px;
        }
        a {
          text-decoration: none;
        }
        .margin-top {
          margin-top: 0.5rem;
        }
      `}</style>
        </div>
    );
}

export default StockTransactionListPage;

export const Route = createFileRoute('/_authenticated/stocktransaction/list')({ component: StockTransactionListPage })
